// Go service routes, through plugins/02.api.ts (browser: @core's $ajax helpers; server:
// direct requests for the visitor's tenant). Looked up before the first await, while the
// calling component's or useAsyncData handler's Nuxt context is still active.
const api = () => useNuxtApp().$api

export const fetchUpdates = async () => {
    var res = await api().get("/public/updates");

    console.dev("fetchUpdates", res)

    return (res && res.data)? res.data: [];
}

export const fetchUpdate = async (id: string | null) => {
    if (!id) return null;

    var res = await api().get("/public/update?id=" + id);
    console.dev("fetchUpdate", res)

    return (res && res.data)? res.data: [];
}

export const fetchMembershipTypes = async () => {
    var res = await api().get("/public/membership-types");

    console.dev("fetchMembershipTypes", res)

    return (res && res.data)? res.data: [];
}

export const fetchPrograms = async () => {
    var res = await api().get("/public/programs");

    console.dev("fetchPrograms", res)

    return (res && res.data)? res.data: [];
}

export const fetchMemberInfo = async () => {
    var res = await api().get("/public/member-info");

    console.dev("fetchMemberInfo", res)

    return (res && res.data)? res.data: [];
}

export const fetchMemberRegister = async (data: any) => {
    var res = await api().post("/public/member-register", data);

    console.dev("fetchMemberRegister", res)

    return (res && res.data)? res.data: [];
}

export const fetchProgramSubscribe = async (data: any) => {
    var res = await api().post("/public/program-subscribe", data);

    console.dev("fetchProgramSubscribe", res)

    return (res && res.data)? res.data: [];
}

export const submitEventCheckout = async (data: any) => {
    var res = await api().post("/public/event-checkout", data);

    console.dev("submitEventCheckout", res)

    return (res && res.data)? res.data: [];
}

export const fetchEventPaymentOptions = async (data: any) => {
    var res = await api().post("/public/event-checkout-payment-options", data);

    console.dev("fetchEventPaymentOptions", res)

    return (res && res.data)? res.data: null;
}

export const createEventPayment = async (data: any) => {
    var res = await api().post("/public/event-checkout-payment", data);

    console.dev("createEventPayment", res)

    return (res && res.data)? res.data: null;
}

export const checkEventPaymentStatus = async (data: any) => {
    var res = await api().post("/public/event-checkout-payment-status", data);

    console.dev("checkEventPaymentStatus", res)

    return (res && res.data)? res.data: null;
}

export const fetchEvents = async () => {
    var res = await api().get("/public/fetch-events");

    console.dev("fetchEvents", res)

    return (res && Array.isArray(res.data))? res.data: [];
}

export const fetchSingleEvent = async (data: {id?: any, slug?: any}) => {
    const body: any = {};
    if(data.id) {
        body.key = "id";
        body.value = data.id;
    } else if(data.slug) {
        body.key = "slug";
        body.value = data.slug;
    }

    var res = await api().post(`/public/fetch-event-single`, body);

    // console.dev("fetchSingleEvent", res)

    return (res && res.data)? res.data: null;
}


export const membershipRegistrationSteps = [
    { title: 'Choose Your Membership', description: 'Select the tier that best fits your current needs.', rules: ["membershipTypeId"] },
    { title: 'Personal Information', description: 'Help us set up your profile for a localized experience.', rules: ["firstName", "lastName", "email", "phone",] },
    { title: 'Extract Information', description: 'Fill in the required fields to complete your registration.', rules: ["customFormValues"] },
    { title: 'Review & Confirm', description: 'Final check before you join the Dephics community.', rules: [] }
]